// @ts-check
import { useState } from 'react';
import { Flex, Padding } from 'components/base/layout-components';
import { LINE_HEIGHT } from 'common/constants/sizes';
import Text from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const AvoidNotificationsDuplicationModal = ({
  NotificationCurrentlyTurnedOn,
  NotificationUserWantsToTurnedOn,
  onConfirm = () => {},
  onCancel = () => {},
  title
}) => {
  const [saving, setSaving] = useState(false);

  return (
    <Flex direction='column' padding='medium'>
      <Flex pb='medium' items='center'>
        <Text size='x-x-large'>{title}</Text>
      </Flex>
      <Flex pb='x-small' items='center'>
        <Text size='large' lineHeight={LINE_HEIGHT.large}>
          <NotificationCurrentlyTurnedOn />
        </Text>
      </Flex>
      <Flex items='center'>
        <Text size='large' lineHeight={LINE_HEIGHT.large}>
          <NotificationUserWantsToTurnedOn />
        </Text>
      </Flex>
      <Flex items='center' pt='big' justify='flex-end'>
        <LBButton variant='outline' onClick={onCancel}>
          Keep turned off
        </LBButton>

        <Padding l='small'>
          <LBButton
            disabled={saving}
            onClick={async () => {
              setSaving(true);
              await onConfirm();
              setSaving(false);
            }}
          >
            Turn on anyway
          </LBButton>
        </Padding>
      </Flex>
    </Flex>
  );
};

export default AvoidNotificationsDuplicationModal;
